module.exports = __webpack_public_path__ + "img/kiks_solo.b85bce45.png";